/** Legacy FinancePage tab indices (financeTargetTab deep links). */
export const FINANCE_TAB = {
  MEMBERS: 0,
  /** Redirects to TrainingGroupsPage — not shown on FinancePage anymore. */
  GROUP_LIST: 1,
  GROUP_COSTS: 2,
  PAYMENT_SETTINGS: 3,
  NOTICES: 4,
  OPT_OUTS: 5,
  MEMBERSHIP_INACTIVE: 6,
  EXPENSES: 7,
  CHART_OF_ACCOUNTS: 8,
};

/** Economy sub-nav order (UI index → FINANCE_TAB). */
export const ECONOMY_TAB_ORDER = [
  FINANCE_TAB.MEMBERS,
  FINANCE_TAB.MEMBERSHIP_INACTIVE,
  FINANCE_TAB.GROUP_COSTS,
  FINANCE_TAB.CHART_OF_ACCOUNTS,
  FINANCE_TAB.NOTICES,
  FINANCE_TAB.OPT_OUTS,
  FINANCE_TAB.EXPENSES,
  FINANCE_TAB.PAYMENT_SETTINGS,
];

export function legacyTabToEconomyUiIndex(tab) {
  const idx = ECONOMY_TAB_ORDER.indexOf(tab);
  return idx >= 0 ? idx : 0;
}

/** i18n keys for Economy tab labels (breadcrumb suffix). */
export const FINANCE_TAB_LABEL_KEYS = {
  [FINANCE_TAB.MEMBERS]: "finance_members",
  [FINANCE_TAB.MEMBERSHIP_INACTIVE]: "finance_membership_inactive_tab",
  [FINANCE_TAB.GROUP_COSTS]: "finance_group_costs",
  [FINANCE_TAB.CHART_OF_ACCOUNTS]: "finance_chart_of_accounts",
  [FINANCE_TAB.NOTICES]: "finance_notices_tab",
  [FINANCE_TAB.OPT_OUTS]: "finance_opt_outs_tab",
  [FINANCE_TAB.EXPENSES]: "settings_expenses",
  [FINANCE_TAB.PAYMENT_SETTINGS]: "finance_payment_settings",
};
